import styled from "@emotion/styled";
import LinesEllipsis from "react-lines-ellipsis";

export const StyledLinesEllipsis = styled(LinesEllipsis)(({ theme }) => ({
  wordBreak: "break-word",
  fontSize: "14px",
}));
